export const iconFontAwesomeBuildingsTents = (
	<i className="fa-solid fa-tents"></i>
);
